import React, { useContext, useState, useEffect } from "react";
import { Button, Dropdown, Form } from "react-bootstrap";
import { Link, Navigate } from "react-router-dom";
import { IoIosArrowDropdown } from "react-icons/io";
import { Newusermodal } from "../pages/Modal";
import { BASE_URL_API_TRANXT_UAT_API } from "../utils/Constant";
import "bootstrap/dist/css/bootstrap.min.css";
import { GlobalContext } from "../Context/GlobalState";
import { twoDecimalPlaces } from "../utils/utilFuctions";
import { billpunchbasicauth } from "../utils/Credentials";
import SecurityWrapper from "../SecurityWrapper";
const Navbar = () => {
  const { user, userparent, setUserInfo, setTransactionLoaderState, setUser } =
    useContext(GlobalContext);
  const { password, username } = billpunchbasicauth;
  const [Wallet, setWallet] = useState(null);
  const [employeeFirms, setEmployeeFirms] = useState([]);
  const [Employeewallet, setEmployeewallet] = useState({});
  const [firmDetails, setFirmDetails] = useState(null);
  const [newuser, setnewuser] = useState(false);
  const getWallet = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const body = JSON.stringify({ firmid: user.firm_id });

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/Salary/GetFirmWalletBalance`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body,
        }
      );
      const data = await res.json();

      if (data.status === "0" && data.data?.length > 0) {
        setWallet(data.data[0]);
      } else {
        setWallet(null);
      }
    } catch (error) {
      // console.error(error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const getemployeeWallet = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const body = JSON.stringify({ firmid: user.firm_id, empid: user.userid });

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetEmployeeWalletBalance`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body,
        }
      );
      const data = await res.json();

      if (data.status === "0" && data.data?.length > 0) {
        setEmployeewallet(data.data[0]);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const basicdetail = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const body = JSON.stringify({
        firmid: user.firm_id,
        parentid: userparent.parentAccountId,
      });

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetFirmBasicDetails`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body,
        }
      );
      const data = await res.json();

      if (data.status === "0" && data.msg === "Success") {
        setFirmDetails(data.data[0]);
      } else {
        console.error("Firm details fetch error: ", data.msg);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const GetAllFirmEmployee = async () => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const body = JSON.stringify({ empid: user.userid });

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetAllFirmEmployee`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body,
        }
      );

      const data = await res.json();
      if (data.status === "0") {
        setEmployeeFirms(data.data);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const handleFirmSelection = async (selectedFirmId) => {
    setTransactionLoaderState(true);
    try {
      const base64Credentials = btoa(`${username}:${password}`);

      const body = JSON.stringify({
        empid: user.userid,
        firmid: String(selectedFirmId),
      });

      const res = await fetch(
        `${BASE_URL_API_TRANXT_UAT_API}/api/SuperAdmin/GetAllFirmDetailsEmployee`,
        {
          method: "POST",
          headers: {
            Authorization: `Basic ${base64Credentials}`,
            "Content-Type": "application/json",
          },
          body,
        }
      );

      const data = await res.json();

      if (data.responseCode === "00") {
        setFirmDetails(data.response);
        setUserInfo(data.response);
      } else {
        console.error("Firm selection error: ", data.msg);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setTransactionLoaderState(false);
    }
  };
  const Logout = () => {
    sessionStorage.clear();
    localStorage.clear();
  
    setUserInfo(null); 
    // setUser(null);
  
    window.history.pushState(null, "", window.location.href);
    window.onpopstate = function () {
      window.history.go(1); 
    };
  
    const callbackUrl = window.location.origin;
    window.location.replace(`https://accounts.seobix.com/?callback=${callbackUrl}`);
  };
  
  useEffect(() => {
    if (!user) {
      window.location.href = `https://accounts.seobix.com/?callback=${window.location.origin}`;
    }
  }, [user]);
  useEffect(() => {
    if (user && user.us_type === "A") {
      getWallet();
    } else if (user && ["E", "H"].includes(user.us_type)) {
      getemployeeWallet();
    }
  }, [user]);
  useEffect(() => {
    GetAllFirmEmployee();
  }, []);
  useEffect(() => {
    if (user && userparent) {
      basicdetail();
    }
  }, [user, userparent]);
  useEffect(() => {
    if (firmDetails?.is_firstLogin === "Y") {
      setnewuser(true);
    }
  }, [firmDetails]);
  if (!user || !user.us_type) {
    return <Navigate to="/" replace />;
  }
  return (
    <>
    <SecurityWrapper>
      
      <nav className="navbar navbar-expand-lg navbar-light bg-white fixed-top shadow-sm">
        <div className="container-fluid d-flex justify-content-between align-items-center px-3">
          <Link to="/" className="navbar-brand d-flex align-items-center">
            <img
              src={require("../assets/images/logoblack.png")}
              alt="logo"
              style={{ height: "2rem", width: "auto" }}
            />
          </Link>
          <ul className="navbar-nav d-flex align-items-center">
            <li className="nav-item px-3">
              <div className="text-dark fw-bold">
                {user.us_type === "A"
                  ? `Firm Bal: ₹ ${twoDecimalPlaces(Wallet?.wl_balance) ?? "Loading..."}`
                  : `Emp Bal: ₹ ${twoDecimalPlaces(Employeewallet?.wl_balance) ?? "Loading..."}`}
              </div>
            </li>

            <Dropdown as="li" className="nav-item px-2">
              <Dropdown.Toggle
                as="a"
                className="nav-link d-flex align-items-center text-dark"
                style={{ cursor: "pointer" }}
              >
                <img
                  src={user.profile_url}
                  alt="profile"
                  className="rounded-circle"
                  style={{
                    width: "2.5rem",
                    height: "2.5rem",
                    objectFit: "cover",
                  }}
                />
                <div className=" px-2 d-flex flex-column justify-content-center">
                  <span
                    style={{
                      fontWeight: "",
                      fontSize: "0.8rem",
                    }}
                    className="text-right"
                  >
                    <span style={{ fontWeight: "500", fontSize: ".9rem" }}>
                      {user.username}
                    </span>
                  </span>
                  <span
                    style={{ fontWeight: "500", fontSize: ".9rem" }}
                    className="text-right"
                  >
                    {`${user.organization}`}
                  </span>
                </div>
                <IoIosArrowDropdown size={20} className="ms-1" />
              </Dropdown.Toggle>
              <Dropdown.Menu
                align="end"
                style={{
                  backgroundColor: "white",
                  padding: "0.5rem",
                  border: "1px solid #ccc",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                  zIndex: 2000,
                }}
              >
                {employeeFirms.map((firm) => (
                  <Dropdown.Item
                    key={firm.firmid}
                    onClick={() => handleFirmSelection(firm.firmid)}
                    style={{ padding: "0.3rem 1rem", cursor: "pointer" }}
                  >
                    <Form.Check
                      type="radio"
                      name="firmSelection"
                      label={firm.firm_name}
                      checked={firm.firmid === user.firm_id}
                    />
                  </Dropdown.Item>
                ))}
                <Dropdown.Divider />
                <Dropdown.Item
                  onClick={Logout}
                  style={{ padding: "0.3rem 1rem", cursor: "pointer" }}
                >
                  <Button size="sm" variant="danger">
                    Logout
                  </Button>
                </Dropdown.Item>
              </Dropdown.Menu>
            </Dropdown>
          </ul>
        </div>
      </nav>
      <Newusermodal showModal={newuser} setShowModal={setnewuser} />
      </SecurityWrapper>
    </>
  );
};

export default Navbar;
